export const hotKey = {
  namespaced: true,
  state: {
    hotKeyFilterFocus: false,
    hotKeySave: false,
    hotKeyCreateNew: false,
    hotKeyEdit: false,
    hotKeyPopupMode: false
  },
  actions: {
    setHotKeyFilterFocus({ commit }, payload) {
      commit('hotKeyFilterFocus', payload);
    },
    setHotKeySave({ commit }, payload) {
      commit('hotKeySave', payload);
    },
    setHotKeyCreateNew({ commit }, payload) {
      commit('hotKeyCreateNew', payload);
    },
    setHotKeyEdit({ commit }, payload) {
      commit('hotKeyEdit', payload);
    },
    setHotKeyPopupMode({ commit }, payload) {
      commit('hotKeyPopupMode', payload);
    },
  },
  mutations: {
    hotKeyFilterFocus(state, payload) {
      state.hotKeyFilterFocus = payload;
    },
    hotKeySave(state, payload) {
      state.hotKeySave = payload;
    },
    hotKeyCreateNew(state, payload) {
      state.hotKeyCreateNew = payload;
    },
    hotKeyEdit(state, payload) {
      state.hotKeyEdit = payload;
    },
    hotKeyPopupMode(state, payload) {
      state.hotKeyPopupMode = payload;
    },
  },
  getters: {
    getHotKeyFilterFocus(state) {
      return state.hotKeyFilterFocus;
    },
    getHotKeySave(state) {
      return state.hotKeySave;
    },
    getHotKeyCreateNew(state) {
      return state.hotKeyCreateNew;
    },
    getHotKeyEdit(state) {
      return state.hotKeyEdit;
    },
    getHotKeyPopupMode(state) {
      return state.hotKeyPopupMode;
    }
  }
};
